import {
  Users,
  Package,
  Warehouse,
  FileBarChart,
  ShoppingCart
} from "lucide-react";
import { useNavigate } from "react-router-dom";

const links = [
  {
    title: "Users",
    icon: Users,
    path: "/profile/alladmin",
    bg: "from-blue-500 to-blue-400"
  },
  {
    title: "Products",
    icon: Package,
    path: "/manage-products/products",
    bg: "from-green-500 to-green-400"
  },
  {
    title: "Orders",
    icon: ShoppingCart,
    path: "/orders/view-order",
    bg: "from-purple-500 to-purple-400"
  },
  {
    title: "Warehouses",
    icon: Warehouse,
    path: "/manage-products/location",
    bg: "from-indigo-500 to-indigo-400"
  },
  {
    title: "Sales Report",
    icon: FileBarChart,
    path: "/reports/sales-reports",
    bg: "from-orange-500 to-orange-400"
  },
  {
    title: "Inventory Report",
    icon: FileBarChart,
    path: "/reports/inventory-reports",
    bg: "from-gray-500 to-gray-400"
  }
];

const SuperAdminQuickLinks = () => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 border-l border-slate-200">
      {links.map((link, i) => {
        const Icon = link.icon;

        return (
          <div
            key={i}
            onClick={() => navigate(link.path)}
            className={`
              relative cursor-pointer p-5 text-white overflow-hidden transition-all
              bg-gradient-to-br ${link.bg}
              border-r border-b border-white/10
              hover:opacity-90 active:scale-[0.98]
            `}
          >
            {/* GLASS BLUR EFFECT */}
            <div className="absolute inset-0 bg-white/10 blur-2xl rounded-full -top-10 -left-10 w-32 h-32"></div>
            
            <p className="text-[10px] opacity-70 relative z-10 font-bold uppercase tracking-widest mb-1">
              Quick Link
            </p>
            
            <h2 className="text-base font-bold relative z-10 truncate">
              {link.title}
            </h2>

            <div className="mt-4 flex items-center justify-between relative z-10">
               <div className="p-2 rounded-lg bg-white/20">
                  <Icon size={16} />
               </div>
               <span className="text-[9px] font-bold opacity-60 uppercase tracking-tighter">
                 Explore
               </span>
            </div>
          </div>
        );
      })}
    </div>

  );
};



export default SuperAdminQuickLinks;
